export const calcBlocks = (blockSize, size) => {
    let i = 0;
    const items = [];
    while (size > 0) {
        if (size < blockSize) {
            blockSize = size;
        }
        const item = {
            seq: ++i,
            size: blockSize,
        };
        items.push(item);
        size -= blockSize;
    }
    return items;
};

export const randomToken = () => Math.random().toString(36).slice(2);

export const FileStatus = {
    ERROR: -1,
    WAITING: 0,
    UPLOADING: 1,
    PAUSE: 2,
    COMPLETE: 3,
};

export const WorkerStatus = {
    IDLE: 0,
    BUSY: 1,
};

export const ErrorCodes = {
    OK: 0,
    USER_ABORT: 1,
    CALC_MD5_FAILED: 2,
    PREPARE_UPLOAD_FAILED: 3,
    COMMIT_BLOCKS_FAILED: 4,
    UPLOAD_FILE_FAILED: 5,
    MERGE_FILE_FAILED: 6,
    UNKNOWN: 7,
}

export const bytesToSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}